/* Renewi color palette
 * The scss colors config for this site can be found at ../../scss / 01-settings / _colors.scss
 *
*/

const RenewiPalette = {
  aqua: {
    base: '#bee6e6'
  },
  black: {
    base: '#000000'
  },
  blue: {
    lighter: '#009de0',
    light: '#0090ce',
    base: '#0055a0'
  },
  green: {
    light: '#78be20',
    base: '#629c19'
  },
  grey: {
    dark: '#404040',
    base: '#737373',
    medium: '#a6a6a6',
    light: '#d9d9d9',
    lighter: '#f6f6f6'
  },
  orange: {
    base: '#F5A623'
  },
  purple: {
    base: '#aa3787'
  },
  red: {
    base: '#d40012'
  },
  white: {
    base: '#ffffff'
  },
  yellow: {
    base: '#ffdc00'
  }
}

export const colors = {
  primary1Color: RenewiPalette.green.light,
  primary1HoverColor: RenewiPalette.green.base,
  primary2Color: RenewiPalette.blue.light,
  primary2HoverColor: RenewiPalette.blue.lighter,
  primary3Color: RenewiPalette.grey.base,
  primary3HoverColor: RenewiPalette.grey.medium,
  accent1Color: RenewiPalette.blue.light,
  accent2Color: RenewiPalette.grey.light,
  accent3Color: RenewiPalette.grey.lighter,
  textColor: RenewiPalette.grey.base,
  secondaryTextColor: RenewiPalette.blue.base,
  alternateTextColor: RenewiPalette.blue.light,
  canvasColor: RenewiPalette.white.base,
  borderColor: RenewiPalette.grey.light,
  disabledColor: RenewiPalette.grey.light,
  shadowColor: RenewiPalette.black.base,
  orange: RenewiPalette.orange.base
}

export const breakpoints = [20, 45, 64, 81.25].map(n => n + 'em')

export const space = [0, 4, 8, 16, 32, 64, 128]

export const fontSizes = [12, 14, 16, 20, 24, 32, 48, 64, 72, 96]

export const radii = [0, 2, 4]

export const fonts = {
  0: `Source Sans Pro,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif;`,
  sans: `Source Sans Pro,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif;`,
  mono: '"SF Mono", "Roboto Mono", Menlo, monospace'
}

export const fontWeights = {
  normal: 400,
  bold: 700
}

export const shadows = ['none', `0 10px 30px 0 rgba(0,0,0,.07)`]

export default {
  breakpoints,
  space,
  fonts,
  fontSizes,
  fontWeights,
  colors,
  radii,
  shadows
}
